import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { CardModule } from '../../common/card/card.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { SelectableCardComponent } from './selectable-card.component';

@NgModule({
  declarations: [SelectableCardComponent],
  exports: [SelectableCardComponent],
  imports: [CommonModule, CheckboxModule, CardModule, ReactiveFormsModule],
})
export class SelectableCardModule {}

export { SelectableCardComponent } from './selectable-card.component';
